(function() {
	'use strict';

	angular.module('qbePortal').controller('QBSaveQuote', QBSaveQuote);

	QBSaveQuote.$inject = [
		'$scope',
		'quoteModelFactory',
		'portalServiceWrapper',
		'userInputRepository',
		'quoteOptions',
		'labelService',
		'ipCookie',
		'gtmService',
		'quoteRequestRepository',
	];

	function QBSaveQuote(
		$scope,
		quoteModelFactory,
		portalServiceWrapper,
		userInputRepository,
		quoteOptions,
		labelService,
		ipCookie,
		gtmService,
		quoteRequestRepository
	) {
		$scope.$root.$on('open-modal', openModal);

		var vm = this;

		vm.opened = false;
		vm.isError = false;

		function openModal() {
			vm.label = labelService.getLabelFor('saveQuoteEmail');
			var quoteModel = quoteModelFactory.create();

			vm.email = quoteModel.email;
			vm.quoteNo = quoteModel.quoteId;
			vm.opened = true;

			if (vm.email !== undefined && vm.email !== null) {
				vm.showForm = false;
				saveQuote();
			} else {
				vm.showForm = true;
			}
		}

		function saveQuote() {
			// Call MA service here to send email
			portalServiceWrapper.updateQuote(userInputRepository.get());

			var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

			portalServiceWrapper
				.saveQuote(paymentFrequency)
				.then(function(resp) {
					$scope.$root.$broadcast('perform-ma-service', 'save');
					var quoteModel = quoteModelFactory.create();
					vm.email = quoteModel.email;
					vm.quoteNo = quoteModel.quoteId;

					ipCookie('QBE_portal_vehicle_quote_id', vm.quoteNo, {
						path: '/'
					});

					// Show mini spinner
					vm.showForm = false;

					// If quoteId found and email found, triggerGoal service quote
					var qr = quoteRequestRepository.getSaveQuoteRequest(paymentFrequency);
					if (qr && qr.quoteID && vm.email) {
						portalServiceWrapper.triggerGoalSaveQuote();
					}

					$scope.$root.$broadcast('save-quote-success');

					return resp;
				})
				.catch(function(err) {
					$scope.$root.$broadcast('error', {
						errorMessage: 'Save quote error',
						response: err
					});
					return err;
				});
		}

		vm.saveForm = function(form) {
			if (form.$valid) {
				gtmService.trackEvent('save');
				userInputRepository.update({ email: vm.email });
				saveQuote();
			} else {
				// console.info('Please enter an email');
				vm.isError = true;
			}
		};

		vm.closeModal = function() {
			vm.opened = false;
			vm.email = null; // clear email field
			$scope.$root.$broadcast('close-modal', { modal: 'saveQuote' });
		};

		vm.getSectionLabelFor = function(fieldName) {
			return labelService.getSectionLabelFor(fieldName);
		};

		vm.getSectionDescriptionFor = function(fieldName) {
			return labelService.getSectionDescriptionFor(fieldName);
		};
	}

	angular.module('qbePortal').component('qbSaveQuote', {
		templateUrl: '../ngviews/components/qbSaveQuote.html',
		controller: QBSaveQuote,
		controllerAs: 'vm',
		bindings: {
			email: '<'
		}
	});
})();
